import { prepareHeaders } from './utils';
import { config } from '../config';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

interface ManEulaStatus {
    account_id: string;
    status: string;
    channel?: string;
    eula_version?: string;
    event_timestamp?: string;
    legal_principal?: Record<string, string>;
    authenticated_subject?: string;
    client_id?: string;
    vin_snapshot?: string[];
    etag: string;
}

export const iamApi = createApi({
    reducerPath: 'iamApi',
    baseQuery: fetchBaseQuery({
        baseUrl: config.backend.iamApi,
        prepareHeaders,
    }),
    tagTypes: ['Eula'],
    endpoints: builder => ({
        fetchEulaStatus: builder.query<ManEulaStatus, string>({
            query: accountId => ({
                url: `/accounts/${accountId}/man-eula-status`,
                responseHandler: async (response: Response) => {
                    const data = await response.json();
                    return {
                        ...data,
                        etag: response.headers.get('ETag') || '',
                    };
                },
            }),
            // keepUnusedDataFor: 10,
            providesTags: ['Eula'],
        }),

        updateEulaStatus: builder.mutation<
            void,
            {
                accountId: string;
                etag: string;
                status: string;
                channel: string;
                eulaVersion: string;
                firstName: string;
                lastName: string;
                contactInfo: string;
                profileId: string;
                vinSnapshot: string[];
            }
        >({
            query: ({ accountId, etag, ...update }) => ({
                url: `/accounts/${accountId}/man-eula-status`,
                method: 'POST',
                headers: new Headers([['If-Match', etag]]),
                body: {
                    status: update.status,
                    channel: update.channel,
                    eula_version: update.eulaVersion,
                    legal_principal: {
                        first_name: update.firstName,
                        last_name: update.lastName,
                        contact_info: update.contactInfo,
                        rio_user_profile_id: update.profileId,
                    },
                    vin_snapshot: update.vinSnapshot,
                },
            }),
            invalidatesTags: ['Eula'],
        }),
    }),
});

export const { useFetchEulaStatusQuery, useUpdateEulaStatusMutation } = iamApi;
